module.exports = __webpack_public_path__ + "static/img/spl.d964ade.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/spl.png
// module id = kd/5
// module chunks = 44